/**
 *
 * AddQuestinarie
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledDropDownList,
  StyledFormField,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import { Group } from '../../../Groups/groups';
import { Language, Questionnaire } from '../../questionnaires';
import QuestionnarieService from '../../../../service/Questionnarie.service';

interface IProps {
  onCancel: () => void;
  onSave: (g: Partial<Group>) => void;
  question?: Questionnaire;
}

const AddQuestinarie: FunctionComponent<IProps> = ({
  onCancel,
  onSave,
  question,
}) => {
  const intl = useIntl();
  const [questionState, setQuestionState] = useState<Partial<Questionnaire>>(
    question || {},
  );
  const [listLangs, setListLangs] = useState<Language[]>([]);

  useEffect(() => {
    QuestionnarieService.fetchListLanguges().then((res) => {
      setListLangs(res);
    });
  }, []);

  const itemFromValue = (value: any) => {
    return listLangs.find((item) => item.id === value);
  };

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.language)}</StyledLabel>
              <StyledDropDownList
                data={listLangs}
                textField="name"
                value={itemFromValue(questionState.languageId)}
                onChange={(e) => {
                  setQuestionState({
                    ...questionState,
                    languageId: e.value.id,
                  });
                }}
              />
            </Column>
          </Wrap>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.name)}</StyledLabel>
              <StyledFormField>
                <Input
                  onChange={(e) =>
                    setQuestionState({
                      ...questionState,
                      name: e.target.value as string,
                    })
                  }
                  value={questionState?.name}
                />
              </StyledFormField>
            </Column>
            <Wrap width={'100%'} margin={'2rem 0 0 0'}>
              <Column xs={100} md={100}>
                <StyledLabel>
                  {intl.formatMessage(messages.description)}
                </StyledLabel>
                <StyledFormField>
                  <textarea
                    onChange={(e) =>
                      setQuestionState({
                        ...questionState,
                        text: e.target.value as string,
                        description: e.target.value as string,
                      })
                    }
                    value={questionState?.text}
                  />
                </StyledFormField>
              </Column>
            </Wrap>
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(questionState)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(AddQuestinarie);
